var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfPageFileIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27 27",
    width: 27,
    height: 27,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#225ea8;stroke-linejoin:round}.b{fill:#225ea8}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a",
    d: "m13.5 26.5c-7.2 0-13-5.8-13-13 0-7.2 5.8-13 13-13 7.2 0 13 5.8 13 13 0 7.2-5.8 13-13 13z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m19.5 18.5h-7.8q-0.6 0-1-0.5-0.5-0.4-0.5-1v-9.9q0-0.6 0.5-1 0.4-0.4 1-0.4h4.9l4.3 4.3v7q0 0.6-0.4 1-0.5 0.5-1 0.5zm-3.6-7.8v-3.6h-4.2v9.9h7.8v-6.3zm-7.1 10.6q-0.6 0-1-0.4-0.4-0.4-0.4-1v-9.9h1.4v9.9h7.8v1.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfPageFileIcon);
export default __webpack_public_path__ + "static/media/pdf_page_file_icon.f72b62ab5a16531844e0c588c2725781.svg";
export { ForwardRef as ReactComponent };